import { IconAnalytics20, IconCandidates, IconCvApply20, IconName, IconPeopleExtensiveCoverage20, IconTipLampLight20, IconVacancy20 } from '@alliance/shared/icons'
import { OnboardingCategoriesEnum } from '../models/onboarding-categories.enum'

export const ICONS_BY_CATEGORY_MAP: Record<OnboardingCategoriesEnum, IconName> = {
  [OnboardingCategoriesEnum.whereToStart]: IconTipLampLight20.name,
  [OnboardingCategoriesEnum.candidatesInProject]: IconCandidates.name,
  [OnboardingCategoriesEnum.actionsWithCandidates]: IconCvApply20.name,
  [OnboardingCategoriesEnum.funnel]: IconVacancy20.name,
  [OnboardingCategoriesEnum.statisticsAndAnalytics]: IconAnalytics20.name,
  [OnboardingCategoriesEnum.userRights]: IconPeopleExtensiveCoverage20.name
}
